import { BrowserEventElementId } from '../constants';

export type Options = {
  /** Number of retries, defaults to 10 */
  retryCount?: number;

  /** Milliseconds between checks, defaults to 1000 */
  retryInterval?: number;
};

export default async function getEventElement({
  retryCount = 10,
  retryInterval = 1000
}: Options = {}): Promise<HTMLElement | null> {
  let eventEl = document.getElementById(BrowserEventElementId);

  while (!eventEl && retryCount > 0) {
    await new Promise(resolve => setTimeout(resolve, retryInterval));
    eventEl = document.getElementById(BrowserEventElementId);
    retryCount--;
  }

  return eventEl;
}
